import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const IncidenciasRH = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Incidencias-RH.pdf`;
  /*const pdfUrl = "/pdf/Incidencias-RH.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Incidencias RH</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Incidencias RH" />
      </Container>
    </>
  );
};

 export default IncidenciasRH;
